module.exports = __webpack_public_path__ + "static/media/orange.7492b86b.png";